<template>
  <v-form>
    <v-container fluid>
      <v-layout v-bind="binding">
        <v-flex xs3>
          <v-card>
            <v-container>
              <v-card-title><v-icon left color="#4C728A">warehouse</v-icon>倉庫</v-card-title>

              <!-- 일반사원(판매원):0, 인사관리자:1, 본부담당자:2, 발주확인자:3, ZUMI:9 -->

              <!-- 치바 -->
              <v-layout row wrap>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2' || user.adminRole === '3' || user.adminRole === '9'">
                  <v-btn
                    block
                    color="#4C728A"
                    dark
                    @click="forwardOrderConfirm()"
                    class="admin-menu-btn"
                  >発注依頼確認</v-btn>
                </v-flex>
                
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2' || user.adminRole === '3'">
                  <v-btn 
                    block
                    color="#ff7900"                    
                    :to="{ name: 'admin/ShippingHistory' }"
                    class="admin-menu-btn"
                  >千葉出荷履歴確認CSV</v-btn>
                </v-flex>

                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2' || user.adminRole === '3'">
                  <v-btn
                    block
                    color="#ff7900"                    
                    :to="{ name: 'admin/WarehouseRealtimeStocktaking' }"
                    class="admin-menu-btn"
                  >千葉倉庫在庫確認</v-btn>
                </v-flex>

                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2' || user.adminRole === '3'">
                  <v-btn
                    block
                    color="#4C728A"
                    dark
                    :to="{ name: 'admin/WarehouseStocktaking' }"
                    class="admin-menu-btn"
                  >倉庫在庫棚卸</v-btn>
                </v-flex>

                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#4C728A"
                    dark
                    :to="{ name: 'admin/WarehouseStockManagement' }"
                    class="admin-menu-btn"
                  >倉庫棚卸在庫管理</v-btn>
                </v-flex>

                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#009688"
                    dark
                    :to="{ name: 'admin/WarehouseMaintenance' }"
                    class="admin-menu-btn"
                  >倉庫データ管理</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <div style="height: 20px;"></div>        

        <v-flex xs3>
          <v-card>
            <v-container>
              <v-card-title><v-icon left color="#42b032">store_mall_directory</v-icon>店舗</v-card-title>
              <v-layout row wrap justify-space-around>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#4C728A"
                    dark
                    :to="{ name: 'admin/report-confirm' }"
                    class="admin-menu-btn"
                  >売上報告確認</v-btn>
                </v-flex>                
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#4C728A"
                    dark
                    :to="{ name: 'admin/stockManagement' }"
                    class="admin-menu-btn"
                  >店舗棚卸在庫管理</v-btn>
                </v-flex>
                <!-- 주석을 삭제하면 기능은 사용할수 있다 -->
                <!-- <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#42b032"
                    dark
                    :to="{ name: 'admin/display-store-items-list' }"
                    class="admin-menu-btn"
                  >店舗別表示商品一括登録・削除（既存）</v-btn>
                </v-flex> -->
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#42b032"
                    dark
                    :to="{ name: 'admin/display-store-items-list2' }"
                    class="black-btn admin-menu-btn"
                  >発注表示商品登録・削除（店舗）
                  </v-btn>
                </v-flex>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#42b032"
                    dark
                    :to="{ name: 'admin/display-store-items-list3' }"
                    class="black-btn admin-menu-btn"
                  >発注表示商品登録・削除（商品）
                    <!-- <span class="new-ribbon">NEW</span> -->
                  </v-btn>
                </v-flex> 
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#3261e3"
                    dark
                    :to="{ name: 'admin/store-standard-stock-management' }"
                    class="admin-menu-btn"
                  >店舗在庫・基準在庫管理</v-btn>
                </v-flex>

                <!-- 분석시스템에 있어서 삭제 -->
                <!-- <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#3261e3"
                    dark
                    :to="{ name: 'admin/store-compare-stocktaking' }"
                    class="admin-menu-btn"
                  >店舗棚卸比較</v-btn>
                </v-flex> -->
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#4C728A"
                    dark
                    :to="{ name: 'admin/store-item-list' }"
                    class="admin-menu-btn"
                  >店舗商品一括登録・削除</v-btn>
                </v-flex>                
                <!-- <v-flex xs12 v-if="user.userId === 'system003' || user.userId === '2024005' || user.userId === '2024006'"> -->
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#4C728A"
                    dark
                    :to="{ name: 'sales/new-user-menu' }"
                    class="admin-menu-btn"
                  >店舗発注依頼
                  </v-btn>
                </v-flex>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#FFD700"
                    :to="{ name: 'admin/order-mail-target-store' }"
                    class="admin-menu-btn black--text"
                  >
                    事前連絡店舗管理
                  </v-btn>
                </v-flex>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#FFD700"
                    :to="{ name: 'admin/order-mail-receiver' }"
                    class="admin-menu-btn black--text"
                  >
                    事前連絡店舗の受信者管理
                  </v-btn>
                </v-flex>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#009688"
                    dark
                    class="admin-menu-btn"
                    :to="{ name: 'admin/new-store-maintenance' }"
                  >店舗データ管理</v-btn>
                </v-flex>                
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <div style="height: 20px;"></div>

        <v-flex xs3>
          <v-card>
            <v-container>
              <v-card-title><v-icon left color="#009688">inventory_2</v-icon>商品</v-card-title>
              <v-layout row wrap justify-space-around>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#009688"
                    dark
                    class="admin-menu-btn"
                    :to="{ name: 'admin/new-item-category' }"
                  >商品カテゴリ管理</v-btn>
                </v-flex>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#009688"
                    dark
                    class="admin-menu-btn"
                    :to="{ name: 'admin/new-item-maintenance' }"
                  >商品データ管理</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <div style="height: 20px;"></div>        

        <!-- Incentive -->
        <!-- <v-flex xs3>
          <v-card>
            <v-container>
              <v-card-title><v-icon left color="#ff7900">file_present</v-icon>インセンティブ管理</v-card-title>
              <v-layout row wrap>
                <v-flex xs12 v-if="user.adminRole === '1'">
                  <v-btn
                    block
                    color="#4C728A"
                    dark
                    :to="{ name: 'admin/incentive-calculation' }"
                    class="admin-menu-btn"
                  >インセンティブ計算</v-btn>
                </v-flex>

                <v-flex xs12 v-if="user.adminRole === '1'">
                  <v-btn
                    block
                    color="#4C728A"
                    dark
                    :to="{ name: 'admin/sales-excel-upload' }"
                    class="admin-menu-btn"
                  >月間販売実績アップロード</v-btn>
                </v-flex>

                <v-flex xs12 v-if="user.adminRole === '1'">
                  <v-btn
                    block
                    color="#4C728A"
                    dark
                    :to="{ name: 'admin/partner-store-mapping-maintenance' }"
                    class="admin-menu-btn"
                  >取引先店舗のマッピング</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <div style="height: 20px;"></div> -->

        <!-- CSV -->
        <v-flex xs3>
          <v-card>
            <v-container>
              <v-card-title><v-icon left color="#ff7900">file_present</v-icon>CSVデータ管理</v-card-title>
              <v-layout row wrap>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#009688"
                    dark
                    :to="{ name: 'admin/csvUploadStore' }"
                    class="admin-menu-btn"
                  >店舗データCSV管理</v-btn>
                </v-flex>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#009688"
                    dark
                    :to="{ name: 'admin/csvUploadItem' }"
                    class="admin-menu-btn"
                  >商品データCSV管理</v-btn>
                </v-flex>

                <!-- ドンキ、BICデータ発注依頼アップロード -->
                <!-- <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#009688"
                    dark
                    :to="{ name: 'admin/agency-order-upload' }"
                    class="admin-menu-btn"
                  >ドンキ、BICデータ発注依頼アップロード</v-btn>
                </v-flex> -->

                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#009688"
                    dark
                    :to="{ name: 'admin/csvUploadInvoiceNumber' }"
                    class="admin-menu-btn"
                  >送り状データアップロード</v-btn>
                </v-flex>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#3261e3"
                    dark
                    :to="{ name: 'admin/csvUploadChibaReceiving' }"
                    class="admin-menu-btn"
                  >千葉入荷データアップロード</v-btn>
                </v-flex>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#3261e3"
                    dark
                    :to="{ name: 'admin/csvUploadChibaDeliver' }"
                    class="admin-menu-btn"
                  >千葉出荷データアップロード</v-btn>
                </v-flex>
                
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <div style="height: 20px;"></div>

        <!-- その他 -->
        <v-flex xs3>
          <v-card>
            <v-container>
              <v-card-title><v-icon left color="#4C728A">settings</v-icon>その他</v-card-title>
              <v-layout row wrap justify-space-around>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2' || user.adminRole === '3'">
                  <v-btn
                    block
                    color="#4C728A"
                    dark
                    :to="{ name: 'admin/new-businessContact' }"
                    class="admin-menu-btn"
                  >業務連絡登録</v-btn>
                </v-flex>

                <v-flex xs12 v-if="user.adminRole === '1'">
                  <v-btn
                    block
                    color="#4C728A"
                    dark
                    :to="{ name: 'admin/new-user-upload' }"
                    class="admin-menu-btn"
                  >従業員データ一覧</v-btn>
                </v-flex>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#3261e3"
                    dark
                    :to="{ name: 'admin/new-maker-maintenance' }"
                    class="admin-menu-btn"
                  >製造会社データ管理</v-btn>
                </v-flex>
                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#009688"
                    dark
                    :to="{ name: 'admin/new-supplier-maintenance' }"
                    class="admin-menu-btn"
                  >取引先データ管理</v-btn>
                </v-flex>

                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#009688"
                    dark
                    :to="{ name: 'admin/new-brand-maintenance' }"
                    class="admin-menu-btn"
                  >ブランド名管理</v-btn>
                </v-flex>

                <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
                  <v-btn
                    block
                    color="#009688"
                    dark
                    :to="{ name: 'admin/supplier-brand-maintenance' }"
                    class="admin-menu-btn"
                  >取引先・ブランド関連管理</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>

        <!-- <v-flex xs12 v-if="user.adminRole === '1' || user.adminRole === '2'">
          <v-btn block color="warning" disabled>返品確認</v-btn>
        </v-flex>-->
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment-timezone'
export default {
  created() {
    console.log('created')
    clearInterval(this.$store.state.adminSession.orderConfirmIntervalId)
    this.$store.commit('CLEAR_ADMIN_SESSION')
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    binding() {
      const binding = {}

      if (this.$vuetify.breakpoint.mdAndDown) binding.column = true
      if (this.$vuetify.breakpoint.mdAndUp) binding.row = true

      return binding
    }
  },
  data() {
    return {}
  },
  methods: {
    forwardOrderConfirm() {
      this.$store.commit(
        'SET_ORDER_CONFIRM_SELECTED_SHIPPING_DATE',
        moment(new Date()).format('YYYY/MM/DD')
      )
      this.$router.push({
        name: 'admin/new-order-confirm'
      })
    }
  }
}
</script>

<style>
.new-ribbon-btn {
  position: relative;
  overflow: hidden; /* 리본 잘림 방지 */
}
.new-ribbon {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #e53935;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 10px;
  transform: translate(30%, -50%) rotate(45deg);
  box-shadow: 0 2px 4px rgba(0,0,0,0.25);
  pointer-events: none;
}
.admin-menu-btn .v-btn__content {
  font-family: 'Hiragino Kaku Gothic ProN', 'Meiryo', 'MS PGothic', sans-serif !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  letter-spacing: 0 !important;
  white-space: nowrap !important;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
}
.black-btn .v-btn__content {
  color: #000 !important;
}

</style>
